import Vue from 'vue';

import Vuetify from 'vuetify/lib';

import fr from 'vuetify/src/locale/fr';

import { themeColors } from '@/theme/colors';

Vue.use(Vuetify);

export const vuetify = new Vuetify({
	theme: {
		dark: false,
		themes: themeColors
	},
	icons: {
		iconfont: 'mdiSvg'
	},
	lang: {
		locales: {
			fr
		},
		current: 'fr'
	}
});
